export default "__VITE_ASSET__d8f95818__"